import {getErrorTrackingUtilDefaultInstance} from '/util/error-tracking/error-tracking.util';
import {error as consoleError} from '/util/logger.util';

import {AsyncStorage} from './async-storage';

export const createStorage = ({
  key,
  defaultValue = null,
  parse = JSON.parse,
  serialize = JSON.stringify,
}: any) => {
  const uniqKey = `connect-app-${key}`;

  if (process.env.NODE_ENV === 'development') {
    const allKeys =
      // @ts-expect-error TS(7017): Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
      global.__storageKeys__ || (global.__storageKeys__ = new Set());

    if (allKeys.has(uniqKey)) {
      // throw new Error(
      //   `Seems "${uniqKey}" already used, Please use another key!`,
      // );
    } else {
      allKeys.add(uniqKey);
    }
  }

  const showError = (error: any) => {
    consoleError('--- AsyncStorage error', error, uniqKey);

    getErrorTrackingUtilDefaultInstance().trackError(
      error,
      'AsyncStorage error',
    );
  };

  const setValue = (value: any) =>
    AsyncStorage.setItem(uniqKey, serialize(value)).catch(error => {
      showError(error);
    });

  const getValue = () =>
    AsyncStorage.getItem(uniqKey)
      .then(rawValue => (rawValue ? parse(rawValue) : defaultValue))
      .catch(error => {
        showError(error);

        return defaultValue;
      });

  const clearValue = () =>
    AsyncStorage.removeItem(uniqKey).catch(error => {
      showError(error);
    });

  return {setValue, getValue, clearValue};
};
